import { render, staticRenderFns } from "./HallEventEditCard.vue?vue&type=template&id=6472785a&scoped=true"
import script from "./HallEventEditCard.vue?vue&type=script&lang=js"
export * from "./HallEventEditCard.vue?vue&type=script&lang=js"
import style0 from "./HallEventEditCard.vue?vue&type=style&index=0&id=6472785a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472785a",
  null
  
)

export default component.exports